import React from 'react';

import { COLORS } from '../../../constants';
import { useApp } from '../../../store/AppContext';
import { getInitials } from '../../../utils/format';

/* Cellule nom d'un membre : pastille à ses initiales et nom. */
export default function MemberNameCell({ dev, style }) {
  const { appState } = useApp();
  const dc =
    dev.color || COLORS[(appState.devs || []).findIndex((d) => d.id === dev.id) % COLORS.length];
  return (
    <div style={style}>
      <div className="avatar" style={{ background: dc + '28', color: dc }}>
        {getInitials(dev.nom)}
      </div>
      <div className="min-w-[0]">
        <div className="text-[12.5px] font-bold text-ink whitespace-nowrap overflow-hidden [text-overflow:ellipsis]">
          {dev.nom}
        </div>
      </div>
    </div>
  );
}
